import React, { useEffect } from 'react';

const CONTAINER_ID = 'edscapGamesList';
// O loader do SDK (_xtremepush_games.html.erb) é assíncrono: window.EdscapList
// pode ainda não existir no mount. Aguardamos via polling curto, com teto.
const SDK_POLL_MS = 300;
const SDK_MAX_WAIT_MS = 15000;

// Renderiza o container dos jogos e chama o SDK Edscap assim que estiver pronto.
export default function OrderGamePanel({ userId }) {
  useEffect(() => {
    if (!userId || typeof window === 'undefined') return undefined;

    let initialized = false;
    let waited = 0;

    function tryInit() {
      if (initialized) return true;
      if (window.EdscapList && typeof window.EdscapList.init === 'function') {
        window.EdscapList.init({ userId: String(userId), containerId: CONTAINER_ID });
        initialized = true;
        return true;
      }
      return false;
    }

    if (tryInit()) return undefined;

    const timer = setInterval(() => {
      waited += SDK_POLL_MS;
      if (tryInit() || waited >= SDK_MAX_WAIT_MS) clearInterval(timer);
    }, SDK_POLL_MS);

    return () => clearInterval(timer);
  }, [userId]);

  return <div id={CONTAINER_ID} />;
}
